import { DialogActions } from "@mui/material";
import { styled } from "@iventis/styles";

export const StyledDialogActions = styled(DialogActions)`
    height: 50px;
`;
